import taxonomyQueries from '../queries/taxonomyQueries'

export default function createTaxonomyMap(queryResults) {
  const taxonomyQueryKeys = Object.keys(taxonomyQueries)

  return taxonomyQueryKeys.reduce((acc, taxonomyKey) => ({ ...acc, [taxonomyKey]: queryResults[taxonomyKey].enumValues }), {})
}
